import React from 'react';
import IoTcontent from '../components/IoTcontent';
import Footer from '../components/footer';


const IoTpage = () => {
  return (
    <div className="IoT">
         
          <IoTcontent />
          <Footer />
    </div>
  );
}

export default IoTpage;